import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import React from "react"
import { Card, CardBody, Col, Label, Input, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import { Edit, SkipNext, SkipPrevious } from '@material-ui/icons';
import MaterialTable from 'material-table';
import _valid from "../../validations";
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import TransitEnterexitIcon from '@material-ui/icons/TransitEnterexit';
import Select from 'react-select';
import { Asignado_Estados, TIEMPO_MOSTRAR_ERROR } from "../../ayudas/constantes";
import SweetAlert from "react-bootstrap-sweetalert";

const columns = [
    {
        title: "Codigo",
        field: "articulo.codigo",
        width: 100,
    },
    {
        title: "Nombre",
        field: "articulo.label",
        width: 100,
    },
    {
        title: "Descripcion",
        field: "articulo.descripcion",
        width: 100,
    },
    {
        title: "Serie",
        field: "articulo.serie",
        width: 100
    },
    {
        title: "Entregado a",
        field: "colaborador.label",
        width: 150
    },
    {
        title: "Cantidad",
        field: "cantidad",
        width: 100
    }
];

export class trazabilidadArticulo extends React.Component {
    constructor(props) {
        super(props);
        this.apiRest = new ApiRest(props);
        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
            },
            data: [],
            listaColaboradores: [],
            consulta: {
                codigo: undefined,
                entregado_a: undefined,
                estado: undefined
            },
            timeralert: null
        }
        this.buscar = this.buscar.bind(this);
        this.actualizarValores = this.actualizarValores.bind(this);
    }
    componentDidMount() {
        this.getColaborador();
    }

    getColaborador = () => {
        this.apiRest.get('/colaborador').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ listaColaboradores: this.formatoSelect(resultado) });
            }
        });
    }

    getData(consulta) {
        this.apiRest.put('/trazabilidad', consulta).then(resultado => {
            if (resultado.exitoso) {
                this.setState({ data: resultado.data });
            }
        });
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            consulta: { ...estadoAnterior.consulta, [name]: value }
        }));
    }

    //set colaborador
    setColaborador = asignado => {
        this.setState(estadoAnterior => ({
            consulta: { ...estadoAnterior.consulta, ['entregado_a']: asignado }
        }));
    }

    isObjEmpty(obj) {
        let indicador = 0;
        if (_valid(obj.codigo)) {
            indicador += 1;
        } else if (_valid(obj.entregado_a)) {
            indicador += 1;
        } else if (_valid(obj.estado)) {
            indicador += 1;
        }

        if (indicador !== 0) {
            return true
        } else {
            return false
        }
    }

    //formato a valores de colaborador
    formatoSelect = valores => valores.data.map(i => ({ value: i.id, label: i.nombres + " " + i.apellidos }));

    buscar = () => {
        const {
            consulta
        } = this.state

        if (this.isObjEmpty(consulta)) {
            this.getData(consulta);
        } else {
            toastr.error('Seleccione un filtro por favor');
        }
    }

    trazarArticulo = (e, registro) => {
        this.props.history.replace({ pathname: '/vistaTrazabilidad', registro: registro });
    }

    cancelar = () =>{
        this.setState({ timeralert: null })
    }

    confirmar =(registro) =>{
        this.apiRest.put('/inactivarArticulo/' + registro.idArticulo).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Articulo Inactivo');
                let dataDelete = [];
                dataDelete = this.state.data;
                const index = registro.tableData.id;
                if (index === 0) {
                    this.setState({ data: [] });
                } else {
                    dataDelete.splice(index, 1);
                    this.setState({ data: [] });
                    this.setState({ data: dataDelete });
                }
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
        this.cancelar();
    }

    eliminarRegistro = (e, registro) => {
        const nextmsg = () => (
            <SweetAlert
                warning
                showCancel
                confirmBtnText="Dar de Baja "
                cancelBtnText="Cancelar"
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                title="Dar de Baja"
                onCancel={() => this.cancelar()}
                onConfirm={() => this.confirmar(registro)}
            >
                Esta seguro que quiere darle de baja al Articulo: {registro.articulo.label}.<br></br>
            </SweetAlert>
        )
        this.setState({ timeralert: nextmsg() })
    }

    render() {
        const {
            listaColaboradores,
            consulta
        } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        {this.state.timeralert}
                        <Breadcrumbs title="Lista" breadcrumbItem="Trazabilidad de Activos" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <MDBBtn className="waves-effect" color="primary" onClick={() => this.props.history.replace('/articuloFormulario')}>
                                            <MDBIcon icon="fas fa-tasks" />{' '}
                                            Nuevo
                                        </MDBBtn>
                                        <p />
                                        <Row>
                                            <Col lg={3}>
                                                <Label htmlFor="codigo" className="form-label">
                                                    Codigo
                                                </Label>
                                                <Input
                                                    value={consulta.codigo}
                                                    onChange={this.actualizarValores}
                                                    name="codigo"
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="codigo"
                                                />
                                            </Col>
                                            <Col lg={3}>
                                                <Label htmlFor="estado" className="form-label">
                                                    Estado
                                                </Label>
                                                <select
                                                    value={consulta.estado}
                                                    onChange={this.actualizarValores}
                                                    name="estado"
                                                    className="form-control"
                                                >
                                                    {Asignado_Estados.map(objeto => <option key={objeto.value} value={objeto.value}>{objeto.label}</option>)}
                                                </select>
                                            </Col>
                                            <Col lg={3}>
                                                <Label htmlFor="entregado_a" className="form-label">
                                                    Entregado a
                                                </Label>
                                                <Select
                                                    name="entregado_a"
                                                    options={listaColaboradores}
                                                    value={consulta.entregado_a}
                                                    onChange={this.setColaborador}
                                                />
                                            </Col>
                                        </Row>
                                        <p />
                                        <Row>
                                            <Col lg={3}>
                                                <MDBBtn className="waves-effect" color="success" onClick={this.buscar}>
                                                    <MDBIcon icon="fas fa-search" />{' '}
                                                    Buscar
                                                </MDBBtn>
                                            </Col>
                                        </Row>
                                        <p />
                                        <Row>
                                            <MaterialTable
                                                keyField="id"
                                                title="Lista de Articulos Asignados"
                                                columns={columns}
                                                data={this.state.data}
                                                actions={[
                                                    {
                                                        icon: TransitEnterexitIcon,
                                                        tooltip: 'Trazabilidad',
                                                        onClick: (event, rowData) => this.trazarArticulo(event, rowData)
                                                    },
                                                    {
                                                        icon: DeleteSweepIcon,
                                                        tooltip: 'Dar de baja',
                                                        onClick: (event, rowData) => this.eliminarRegistro(event, rowData)
                                                    }
                                                ]}
                                                options={
                                                    {
                                                        search: false,
                                                        pageSize: 5,
                                                        pageSizeOptions: [5, 10, 25],
                                                        showFirstLastPageButtons: false,
                                                    }
                                                }
                                                localization={
                                                    {
                                                        header: { actions: 'Acciones' },
                                                        pagination: {
                                                            labelRowsSelect: 'Filas',
                                                            labelDisplayedRows: "{from}-{to} de {count}",
                                                            nextTooltip: "Siguiente Pagina",

                                                            previousTooltip: "Anterior Pagina"
                                                        }
                                                    }
                                                }
                                                icons={
                                                    {
                                                        NextPage: SkipNext,
                                                        PreviousPage: SkipPrevious
                                                    }
                                                }
                                            />
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}